// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2631 ? "0c579ea0" : chunkId) + "." + {"2631":"66f1f3bd3d3f27b0","8422":"398fb175876aedd0"}[chunkId] + ".js";
};